import React, { forwardRef } from "react";
import Form from "react-bootstrap/Form";
import { useGetStoresQuery } from "../../../services/api/repositories/StoresRepository";

const Store = forwardRef<HTMLSelectElement, {tabIndex: number}>(
    ({ tabIndex, ...props }, ref) => {

    const {data, isLoading} = useGetStoresQuery();

    const stores = data?.stores.map((store) => {
        return (
            <option key={store.uuid} value={store.uuid}>{store.name} - {store.code}</option>
        );
    });

    return (
        <Form.Group className="form-group filter-store">
            <Form.Label>
                <span className="icon"></span>
                Magasin
            </Form.Label>
            <Form.Select id="filters-store-select" tabIndex={tabIndex}  ref={ref}>
                {isLoading
                    && <option>Chargement...</option>
                }
                {!isLoading && 
                (<>
                    <option value="all">Tous</option>
                    {stores}
                </>)}
            </Form.Select>
        </Form.Group>
    );
});

export default Store;